import React, { useState } from 'react';

import { GetSubAffiliateResponse } from '../../../Api/CRM/Responses/SubAffiliateResponse';
import ActionButton from '../../elements/ActionButton';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import { ROLES } from '../../services/AdminPolicyService';
import axios from '../../services/MyAxios';
import UsersList from '../user/UsersList';

import SubAffiliateDetails from './SubAffiliateDetails';
import SubAffiliateStatistics from './SubAffiliateStatistics';

function SubAffiliateShow() {
    const { id } = useNumberParams();
    const [subAffiliate, setSubAffiliate] = useState<GetSubAffiliateResponse>();
    const url = `/crea/api/sub_affiliate/${id}`;

    const getSubAffiliate = () => {
        axios.get(url).then((response) => setSubAffiliate(response.data));
    };

    useOnce(getSubAffiliate);

    if (!subAffiliate) {
        return null;
    }

    return (
        <>
            {subAffiliate.admin_id === null ? (
                <ActionButton
                    url={`/sub_affiliate/${id}/attach/admin`}
                    title="Attach Admin"
                    roles={ROLES.MAIN_ADMINS}
                />
            ) : null}
            <SubAffiliateDetails subAffiliate={subAffiliate} url={url} getSubAffiliate={getSubAffiliate} />
            <SubAffiliateStatistics url={url} />
            <UsersList short cardTitle="Users" source="subAffiliates" relatedId={id} />
        </>
    );
}

export default SubAffiliateShow;
